import { AppliedFilterInterface, FilterInterface, Select } from '@shopify/polaris'
import { useCallback } from 'react'

import { prepaidDeliveriesOptions } from '../../selling-plan-page/PrePaidDeliveriesField'
import { SubscriptionFilter } from '../api'

const options = prepaidDeliveriesOptions.map((o) => ({
  label: o.label,
  value: String(o.value),
}))

export const useAddPrepaidDeliveriesFilter = (
  filter: SubscriptionFilter,
  updateFilter: (newFilter: Partial<SubscriptionFilter>) => any,
  filters: FilterInterface[],
  appliedFilters: AppliedFilterInterface[]
) => {
  const setPrepaidDeliveries = useCallback(
    (value: string) => {
      const parsed = parseInt(value)
      updateFilter({
        prepaid_deliveries: Number.isFinite(parsed) && parsed > 0 ? parsed : undefined,
      })
    },
    [updateFilter]
  )

  filters.push({
    key: 'prepaid_deliveries',
    label: 'Prepaid deliveries',
    filter: (
      <Select
        label="Prepaid deliveries"
        labelHidden
        options={options}
        value={filter.prepaid_deliveries ? String(filter.prepaid_deliveries) : ''}
        onChange={setPrepaidDeliveries}
        placeholder="Select number of deliveries"
      />
    ),
  })

  if (filter.prepaid_deliveries) {
    appliedFilters.push({
      key: 'prepaid_deliveries',
      label: `Prepaid deliveries: ${filter.prepaid_deliveries}`,
      onRemove: () => updateFilter({ prepaid_deliveries: undefined }),
    })
  }
}
